import { useEffect, useState } from 'react'

export const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    const resizeHandler = () => {
      const compare = (prevValue: typeof size) => {
        if (prevValue.width !== window.innerWidth || prevValue.height !== window.innerHeight) {
          return { width: window.innerWidth, height: window.innerHeight }
        }
        return prevValue
      }
      setSize(compare)
      setTimeout(() => setSize(compare), 10)
    }

    window.addEventListener('resize', resizeHandler)
    return () => window.removeEventListener('resize', resizeHandler)
  }, [])

  return size
}
